module.exports = __webpack_public_path__ + "images/location-icon-black.svg";